import { render, staticRenderFns } from "./Picodent.vue?vue&type=template&id=27ac89bc&"
import script from "./Picodent.vue?vue&type=script&lang=js&"
export * from "./Picodent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports